export default "__VITE_ASSET__KovmoCFl__"